<template>
  <div id="main-content" class="student-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToAddClass()">+ {{ $t('class_list.add_class') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="padding-top: 20px">
        <table class="bus-list filter-sort-table">
          <tr>
            <th width="5%">#</th>
            <th width="30%" class="input-th">
              <el-input :placeholder="$t('common.class')" v-model="filter.name"></el-input>
              <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
            </th>
            <th width="45%">{{ $t('common.grade') }}</th>
            <th>
              <el-button @click="resetFilter"
                         style="margin: 2px;" type="danger">{{ $t('common.reset') }}
              </el-button>
            </th>
          </tr>
          <tr v-for="(classroom, index) in sortedClassList" :key="classroom.id"
              v-show="index >= itemPerPage * (page-1) && index < itemPerPage * page">
            <td width="5%">{{ index + 1 }}</td>
            <td>{{ classroom.name }}</td>
            <td>{{ classroom.grade }}</td>
            <td>
              <b-button variant="outline-primary" @click="goToDetailClass(classroom.id)"
                        style="margin-right: 10px">{{ $t('common.detail') }}
              </b-button>
              <b-button variant="danger" @click="deleteClass(classroom.id, index)">{{ $t('common.delete') }}</b-button>
            </td>
          </tr>
        </table>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
            v-show="sortedClassList.length > itemPerPage"
            background
            @current-change="didSelectPage"
            :page-size="itemPerPage"
            layout="prev, pager, next"
            :current-page="page"
            :total="sortedClassList.length">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import { ITEM_PER_PAGE } from '@/config'
  import PageTitle from '@/components/PageTitle'
  import Sort from '@/components/Sort'

  export default {
    name: 'ListStudent',
    components: {
      PageTitle,
      Sort
    },
    data: function () {
      return {
        backLink: ``,
        title: 'class_list.class_list',
        page: 1,
        itemPerPage: ITEM_PER_PAGE,
        filter: {
          name: ''
        },
        sort: {
          name: 'asc'
        },
        isBack: false
      }
    },
    methods: {
      goToAddClass: function () {
        this.saveState()
        this.$router.push('/classroom/add')
      },
      goToDetailClass(classId) {
        this.saveState()
        this.$router.push({path: '/classroom/detail', query: {cid: classId}});
      },
      saveState: function () {
        this.$store.commit('classroom/updateState', {
          filter: this.filter,
          sort: this.sort,
          page: this.page
        })
      },
      resetFilter: function () {
        this.filter = Object.assign({}, {
          name: ''
        })

        this.sort = Object.assign({}, {
          name: null
        })
      },
      didSelectPage: function (e) {
        this.page = e
      },
      deleteClass(classId, index) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('class_list.class_delete_confirm'),
          callback: () => {
            let successCallback = () => {

            }
            let payload = {
              successCallback,
              class_id: classId,
              index: index
            }

            this.$store.dispatch('classroom/deleteClass', payload)
            if (index == this.sortedClassList.length - 1){
              let pageNumber = (this.sortedClassList.length - 1) / this.itemPerPage
              this.page = Math.ceil(pageNumber)
            }
          }
        })
      },
      changeSort (type, field) {
        this.sort[field] = type
        this.sort = Object.assign({}, this.sort)
      },
      isStringMatched (source, needed) {
        return source.toUpperCase().indexOf(needed.toUpperCase()) !== -1
      },
      toASCII (chars) {
        let ascii = ''

        for(let i = 0, l = chars.length; i < l; i++) {
          let c = chars[i].charCodeAt(0)

          // make sure we only convert half-full width char
          if (c >= 0xFF00 && c <= 0xFFEF) {
            c = 0xFF & (c + 0x20)
          }

          ascii += String.fromCharCode(c)
        }

        return ascii
      }
    },
    mounted: function () {
      this.$store.dispatch('classroom/retrieveClassList', {})
    },
    computed: {
      ...mapState('classroom', ['classList', 'currentFilter', 'currentSort', 'currentPage']),
      filteredClassList: function () {
        let filterName = this.filter.name.trim()

        return this.classList.filter((classItem) => {
          if (filterName && !this.isStringMatched(classItem.name, filterName)) {
            return false
          }

          return true
        })
      },
      sortedClassList: function () {
        let sortedClassList = [].concat(this.filteredClassList)

        sortedClassList.sort((before, after) => {
          if (this.sort.name) {
            let beforeName = this.toASCII(before.name)
            let afterName = this.toASCII(after.name)
            let beforeLevel = beforeName[0]
            let beforeClass = parseInt(beforeName.substring(1))
            let afterLevel = afterName[0]
            let afterClass = parseInt(afterName.substring(1))

            if (beforeLevel !== '小' && beforeLevel !== '中') {
              return 1
            }

            if (afterLevel !== '小' && afterLevel !== '中') {
              return -1
            }

            if (this.sort.name === 'asc') {
              if (beforeLevel === '小' && afterLevel === '中') {
                return -1
              }

              if (beforeLevel === '中' && afterLevel === '小') {
                return 1
              }

              if (beforeClass < afterClass) {
                return -1
              }

              if (beforeClass > afterClass) {
                return 1
              }
            } else {
              if (beforeLevel === '小' && afterLevel === '中') {
                return 1
              }

              if (beforeLevel === '中' && afterLevel === '小') {
                return -1
              }

              if (beforeClass < afterClass) {
                return 1
              }

              if (beforeClass > afterClass) {
                return -1
              }
            }
          }

          return 0
        })

        return sortedClassList
      }
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentFilter) {
          this.filter = Object.assign({}, this.currentFilter)
        }

        if (this.currentSort) {
          this.sort = Object.assign({}, this.currentSort)
        }

        if (this.currentPage) {
          this.page = this.currentPage
        }

        this.isBack = true
      }

      this.$store.commit('classroom/updateState', {
        filter: null,
        sort: null,
        page: null
      })
    },
    watch: {
      filter: {
        deep: true,
        handler: function () {
          if (this.isBack) {
            this.isBack = false
            return
          }

          this.page = 1
        }
      }
    }
  }
</script>
<style lang="scss">
  .bus-list {
    width: 100%;
    /*border: 1px solid #DCDFE6;*/
  }

  table, th, td {
    border: 1px solid #DCDFE6;
    border-collapse: collapse;
  }

  th {
    height: 55px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
  }

  td {
    height: 40px;
  }
</style>